<template>
    <section class="logo-list grid grid__base">
        <div class="grid--container">
            <h2 class="logo-list--title" v-if="title">{{ title }}</h2>
            <ul class="logo-list--collection u-reset grid--row">
                <li class="logo-list--item grid--col" v-for="(item, index) in logos" :key="index">
                    <a target="_blank" class="logo-list--link" :href="getLink(item)">
                        <base-image class="logo-list--image" v-bind="item.logo"/>
                    </a>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            /** @type {ILogo} */
            logos: {
                type: Array,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
        },
        methods: {
            getLink(item) {
                return item.link ? item.link.path : '#';
            },
        },
    };
</script>
